import {motion} from 'framer-motion';

const minorRoles=[
  ['甘海老','Amaebi','Ranger'],
  ['烏賊','Ika','Support / Healer'],
  ['海膽','Uni','Mage / Burst'],
  ['白身','Shiromi','Scout / Assassin']
];

const portraits={
  kuremio: 'https://media-manager-c.questera.ai/greta-media/048a294ccd6718892c549bd7b643fcf120d7d84b38289b7b4b78889b4f78a748e8c921a45f072a6a0302366ee1557436/images/aW1hZ2UvanBlZw==/024766f5fd25eb20670673974c6ba2a9.jpg',
  tamasumi: 'https://media-manager-c.questera.ai/greta-media/048a294ccd6718892c549bd7b643fcf120d7d84b38289b7b4b78889b4f78a748e8c921a45f072a6a0302366ee1557436/images/aW1hZ2UvanBlZw==/75d3787f081804f7eabe0898b072a4b3.jpg'
};

function BloodCard({type,kanji,kana,title,tekuse,role,children}) {
  return (
    <motion.article
      className={`blood-profile blood-profile--${type}`}
      initial={{opacity: 0,y: 35}}
      whileInView={{opacity: 1,y: 0}}
      viewport={{once: true,amount: .2}}
      transition={{duration: .8}}
      whileHover={{y: -7}}
    >
      <div className="blood-profile__portrait">
        <div className="blood-profile__paper" />
        <div className="blood-profile__aura" />
        <img src={portraits[type]} alt={`${kanji}角色全身像`} />
        <div className="blood-profile__particles">
          {Array.from({length: 12},(_,index)=> <i key={index} />)}
        </div>
        <div className="blood-profile__wash" />
        <span className="blood-profile__role">{role}</span>
        <b className="blood-profile__kanji">{kanji}</b>
      </div>

      <div className="blood-profile__copy">
        <div className="blood-profile__name">
          <b>{kanji}</b>
          <span>{kana}</span>
        </div>
        <p className="blood-profile__title">{title}</p>
        <h3>
          <small>手癖 · TEKUSE</small>
          {tekuse}
        </h3>
        <i className="blood-profile__rule" />
        <p className="blood-profile__description">{children}</p>
      </div>
    </motion.article>
  );
}

export default function Bloodline({copy,lang}) {
  return (
    <section className="bloodline section" id="bloodline">
      <style>{`
        .blood-grid {
          gap: clamp(1rem,2.5vw,2.5rem);
          min-height: 0;
        }
        .blood-profile {
          position: relative;
          display: grid;
          grid-template-rows: minmax(520px,62vh) auto;
          overflow: hidden;
          border: 1px solid #302b24;
          background: #0c0b09;
          transition: border-color .55s ease,box-shadow .55s ease;
        }
        .blood-profile:hover {
          border-color: #674336;
          box-shadow: 0 28px 70px rgba(0,0,0,.58);
        }
        .blood-profile__portrait {
          position: relative;
          min-height: 0;
          overflow: hidden;
          background: #d9ccb0;
        }
        .blood-profile__paper {
          position: absolute;
          inset: 0;
          background:
            radial-gradient(circle at 25% 18%,#f0e4ca,#d0c09f 62%,#a99a7d),
            repeating-linear-gradient(0deg,transparent 0 4px,#392a1510 5px);
        }
        .blood-profile__portrait img {
          position: absolute;
          z-index: 2;
          inset: 2.5% 3% 0;
          width: 94%;
          height: 97%;
          object-fit: contain;
          object-position: center bottom;
          mix-blend-mode: multiply;
          filter: saturate(.88) contrast(1.04);
          transition: transform .85s cubic-bezier(.2,.75,.2,1),filter .85s ease;
        }
        .blood-profile:hover .blood-profile__portrait img {
          transform: scale(1.035) translateY(-1%);
          filter: saturate(1.04) contrast(1.08);
        }
        .blood-profile__aura {
          position: absolute;
          z-index: 1;
          inset: 12% 7% 3%;
          opacity: 0;
          transform: scale(.84);
          transition: opacity .65s ease,transform .9s ease;
        }
        .blood-profile:hover .blood-profile__aura {
          opacity: 1;
          transform: scale(1);
        }
        .blood-profile--kuremio .blood-profile__aura {
          background:
            radial-gradient(ellipse at 50% 88%,rgba(229,43,25,.68),transparent 48%),
            radial-gradient(ellipse at 42% 70%,rgba(255,146,53,.36),transparent 38%);
          filter: blur(15px);
          animation: kuremio-flame 1.6s ease-in-out infinite alternate;
        }
        .blood-profile--tamasumi .blood-profile__aura {
          inset: 10% 9% 5%;
          border: 1px solid rgba(192,155,47,.62);
          border-radius: 50%;
          background: radial-gradient(circle,rgba(247,221,116,.2),transparent 62%);
          box-shadow:
            inset 0 0 65px rgba(222,188,73,.2),
            0 0 55px rgba(222,188,73,.28);
          animation: tamasumi-shield 2.2s ease-in-out infinite;
        }
        .blood-profile__particles {
          position: absolute;
          z-index: 3;
          inset: 0;
          overflow: hidden;
          opacity: 0;
          transition: opacity .5s ease;
          pointer-events: none;
        }
        .blood-profile:hover .blood-profile__particles {
          opacity: 1;
        }
        .blood-profile__particles i {
          position: absolute;
          left: calc(8% + (var(--particle) * 7%));
          bottom: 4%;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background: #e9502b;
          box-shadow: 0 0 9px #f4532f;
          animation: rise-particle calc(1.3s + var(--particle) * .08s) linear infinite;
          animation-delay: calc(var(--particle) * -.16s);
        }
        .blood-profile__particles i:nth-child(1) {--particle: 1;}
        .blood-profile__particles i:nth-child(2) {--particle: 2;}
        .blood-profile__particles i:nth-child(3) {--particle: 3;}
        .blood-profile__particles i:nth-child(4) {--particle: 4;}
        .blood-profile__particles i:nth-child(5) {--particle: 5;}
        .blood-profile__particles i:nth-child(6) {--particle: 6;}
        .blood-profile__particles i:nth-child(7) {--particle: 7;}
        .blood-profile__particles i:nth-child(8) {--particle: 8;}
        .blood-profile__particles i:nth-child(9) {--particle: 9;}
        .blood-profile__particles i:nth-child(10) {--particle: 10;}
        .blood-profile__particles i:nth-child(11) {--particle: 11;}
        .blood-profile__particles i:nth-child(12) {--particle: 12;}
        .blood-profile--tamasumi .blood-profile__particles i {
          width: 3px;
          height: 3px;
          background: #e9cf69;
          box-shadow: 0 0 10px #f7e39a;
          animation-duration: 2.3s;
        }
        .blood-profile__wash {
          position: absolute;
          z-index: 4;
          inset: 0;
          pointer-events: none;
          background:
            linear-gradient(180deg,transparent 72%,#0c0b09 100%),
            linear-gradient(90deg,#160f090f,transparent 25% 75%,#160f091f);
        }
        .blood-profile__role {
          position: absolute;
          z-index: 5;
          top: 1.4rem;
          left: 1.4rem;
          padding: .42rem .65rem;
          border: 1px solid #8e2424;
          color: #6d1717;
          background: #e5d8bbdd;
          font: 600 .62rem "Cormorant Garamond";
          letter-spacing: .25em;
        }
        .blood-profile__kanji {
          position: absolute;
          z-index: 5;
          top: 1.2rem;
          right: 1.2rem;
          color: #6d17172c;
          font: 600 clamp(3rem,7vw,6.5rem) "Noto Serif JP";
          writing-mode: vertical-rl;
          transition: color .5s ease;
        }
        .blood-profile:hover .blood-profile__kanji {
          color: #75191452;
        }
        .blood-profile__copy {
          position: relative;
          z-index: 6;
          min-height: 275px;
          margin-top: -1px;
          padding: 2rem clamp(1.4rem,3vw,2.8rem) 2.5rem;
          border-top: 1px solid #392f26;
          background: linear-gradient(120deg,#15110d,#080808 62%);
        }
        .blood-profile__name {
          display: flex;
          align-items: baseline;
          gap: 1rem;
        }
        .blood-profile__name b {
          color: #eee0c6;
          font: 500 clamp(1.75rem,3vw,2.8rem) "Noto Serif JP";
          letter-spacing: .12em;
        }
        .blood-profile__name span {
          color: #9c8b73;
          font: 500 .72rem "Cormorant Garamond";
          letter-spacing: .22em;
        }
        .blood-profile__title {
          margin-top: .45rem;
          color: #766d61;
          font: .66rem "Cormorant Garamond";
          letter-spacing: .2em;
        }
        .blood-profile__copy h3 {
          margin: 1.25rem 0 .9rem;
          color: #e5d4b5;
          font: 500 clamp(1.5rem,2.8vw,2.6rem) "Cormorant Garamond";
          letter-spacing: .04em;
        }
        .blood-profile__copy h3 small {
          display: block;
          margin-bottom: .3rem;
          color: #9e2922;
          font: 500 .57rem "Noto Serif JP";
          letter-spacing: .23em;
        }
        .blood-profile__rule {
          display: block;
          width: 38px;
          height: 1px;
          margin-bottom: 1rem;
          background: #a82520;
          transition: width .5s ease;
        }
        .blood-profile:hover .blood-profile__rule {
          width: 72px;
        }
        .blood-profile__description {
          max-width: 430px;
          color: #a49a8b;
          line-height: 1.8;
        }
        .blood-profile--tamasumi .blood-profile__role {
          color: #68510e;
          border-color: #9a7b20;
        }
        .blood-profile--tamasumi .blood-profile__kanji {
          color: #89732132;
        }
        .blood-profile--tamasumi:hover .blood-profile__kanji {
          color: #89732152;
        }
        .blood-profile--tamasumi .blood-profile__copy h3 small {
          color: #ac8b31;
        }
        .blood-profile--tamasumi .blood-profile__rule {
          background: #a78932;
        }
        @keyframes kuremio-flame {
          from {transform: scale(.95) translateY(12px);filter: blur(18px);}
          to {transform: scale(1.08) translateY(-12px);filter: blur(11px);}
        }
        @keyframes tamasumi-shield {
          50% {transform: scale(1.055);opacity: .66;}
        }
        @keyframes rise-particle {
          0% {transform: translate(0,20px) scale(.5);opacity: 0;}
          25% {opacity: 1;}
          100% {transform: translate(18px,-390px) scale(1.5);opacity: 0;}
        }
        @media (max-width: 800px) {
          .blood-grid {
            display: grid;
            grid-template-columns: 1fr;
          }
          .blood-profile {
            grid-template-rows: minmax(490px,145vw) auto;
          }
          .blood-profile__portrait img {
            inset: 2% 1% 0;
            width: 98%;
            height: 98%;
          }
          .blood-profile__copy {
            min-height: 0;
          }
          .blood-profile__aura {
            opacity: .42;
            transform: scale(1);
          }
          .blood-profile__particles {
            opacity: .38;
          }
        }
        @media (max-width: 420px) {
          .blood-profile {
            grid-template-rows: 520px auto;
          }
          .blood-profile__name {
            align-items: flex-start;
            flex-direction: column;
            gap: .15rem;
          }
        }
        @media (prefers-reduced-motion: reduce) {
          .blood-profile__aura,
          .blood-profile__particles i {
            animation: none;
          }
        }
      `}</style>

      <div className="section-heading compact">
        <span>02 · KEISHŌ</span>
        <h2>{copy.bloodline}</h2>
      </div>

      <div className="blood-grid">
        <BloodCard
          type="kuremio"
          kanji="紅澪"
          kana="KUREMIO"
          title="CONNECTOR OF TASTES · 味覺之間的連結者"
          tekuse="MOE / 燃"
          role="ATTACK"
        >
          {lang==='zh-Hant'
            ? '傾聽食材中殘留的未竟情感，在記憶與現實之間架起橋樑。燃起的一瞬，讓味道抵達未能言明之處。'
            : 'She listens to unfinished feelings within ingredients and bridges memory with the present.'}
        </BloodCard>

        <BloodCard
          type="tamasumi"
          kanji="玉澄"
          kana="TAMASUMI"
          title="KEEPER OF FIRE · 守火之人"
          tekuse="AN / 安"
          role="DEFENSE"
        >
          {lang==='zh-Hant'
            ? '守著不急不躁的火，在變化之中維持溫度與安定。安定的圓環展開時，席間萬物都回到最適切的火候。'
            : 'She tends an unhurried flame,keeping warmth and stability through change.'}
        </BloodCard>
      </div>

      <details className="minor-roles">
        <summary>{copy.roles}<span>＋</span></summary>
        <div className="role-list">
          {minorRoles.map(([jp,name,role])=> (
            <div key={name}>
              <b>{jp}</b>
              <span>{name}</span>
              <em>{role}</em>
            </div>
          ))}
        </div>
      </details>
      <p className="role-note">{copy.roleNote}</p>
    </section>
  );
}